var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFidokey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 63,
    viewBox: "0 0 41 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.991 17.4513C33.4387 17.4513 32.991 17.0036 32.991 16.4513L32.991 6.98208C32.991 6.4298 33.4387 5.98208 33.991 5.98208L39.9999 5.98208L39.9999 17.4513L33.991 17.4513Z",
    fill: "white",
    stroke: "#236AC9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40637 19.3628C5.54038 19.3628 2.40637 16.2288 2.40637 12.3628L2.40637 5.07051C2.40637 4.51822 2.85409 4.07051 3.40637 4.07051L31.3538 4.07051C31.906 4.07051 32.3538 4.51822 32.3538 5.07051L32.3538 18.3628C32.3538 18.9151 31.906 19.3628 31.3538 19.3628L9.40637 19.3628Z",
    fill: "#F2FAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76929 20C5.35101 20 1.76929 16.4183 1.76929 12L1.76929 5.43336C1.76929 4.32879 2.66472 3.43336 3.76929 3.43336L30.991 3.43336C32.0956 3.43336 32.991 4.32879 32.991 5.43336L32.991 18C32.991 19.1046 32.0956 20 30.991 20L9.76929 20Z",
    stroke: "#236AC9",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71623 14.4777C7.71623 14.947 7.33587 15.3273 6.86666 15.3273C6.39746 15.3273 6.01709 14.947 6.01709 14.4777C6.01709 14.0085 6.39746 13.6282 6.86666 13.6282C7.33587 13.6282 7.71623 14.0085 7.71623 14.4777Z",
    fill: "#236AC9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3009 6.83167L38.3009 16.6017",
    stroke: "#2EA76D",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFidokey);
export default __webpack_public_path__ + "static/media/fidokey.8b9cc3ba7e7c8bd2cad961c4d2b92bb7.svg";
export { ForwardRef as ReactComponent };